import { SignStatus } from "gql/graphql";
import { ReactNode } from "react";
import { StatusSigned } from "@/modules/signing/shared/ui/sign-status-handler/status-signed";
import { StatusProcessing } from "@/modules/signing/shared/ui/sign-status-handler/status-processing";
import { StatusQrOpened } from "@/modules/signing/shared/ui/sign-status-handler/status-qr-opened";

export function SignStatusHandler({
  signStatus = SignStatus.Pending,
  onPending,
  onProcessing,
  onQrOpened,
  onSigned,
}: {
  signStatus?: SignStatus;
  onPending: ReactNode;
  onProcessing?: ReactNode;
  onQrOpened?: ReactNode;
  onSigned?: ReactNode;
}) {
  switch (signStatus) {
    case SignStatus.Pending:
      return onPending;
    case SignStatus.Processing:
      return onProcessing ?? <StatusProcessing />;
    case SignStatus.QrOpened:
      return onQrOpened ?? <StatusQrOpened />;
    case SignStatus.Signed:
      return onSigned ?? <StatusSigned />;
    default:
      return null;
  }
}
